import { data } from '@amazon/vinyl-observable'
import { globalData } from '@/util/globalData'

export const modalCount = globalData(() => data(0))
export const modalVisible = modalCount.map((v) => !!v)
export const modalVisibleClass$ = modalVisible.map((v) => (v ? 'modalVisible' : null))
